<main class="page-content">
    <div class="brook-icon-boxes-area ptb--120 ptb-md--80 ptb-sm--60" style="background-color: #34144c;">
       <div class="container">
           <div class="row">
               <div class="col-lg-12">
                   <div class="brook-section-title text-center">
                       <h3 class="heading heading-h3 cd-headline clip is-full-width move-up wow" style="color: rgb(226, 127, 221); margin-top: 40px;">NeuroAkashico®
                           <span class="cd-words-wrapper theme-color">
                               <b class="is-visible" style="color: white;">Transmite</b>
                               <b style="color: white;">Practica</b>
                               <b style="color: white;">Enseña</b>
                           </span> </h3>
                           
                           
                   </div>
               </div>
           </div>
           <div class="row mt--30" *ngIf="cursos">
   
               
               <div class="col-lg-4 col-md-6 col-sm-6 col-12" *ngFor="let cursos of cursos" >
                   <div class="icon-box text-center mt--30">
                       <div class="inner"  >
                           <div class="content">
                               <h5 class="heading heading-h5">{{cursos.titulo}}</h5>
                               <a class="icon-btn" href="{{cursos.link}}"><span>Ver detalles</span><i class="fa fa-arrow-right"></i></a>
                           </div>
                       </div>
                   </div>
               </div>
               
   
             
   
           </div>
       </div>
   </div>
   </main>
   
   
   
   
   
